import styled, { css } from 'styled-components';
import { theme } from '../../theme';

interface InputProps {
  hasError: boolean;
  inputSize: 'sm' | 'base';
}

const pseudoStates = ({ hasError, inputSize }: InputProps) => css`
  & {
    --outline-size: ${inputSize === 'sm' ? '2px' : '4px'};
  }

  &:focus {
    border-color: #0079d1;
    box-shadow: 0 0 0 var(--outline-size) #80bce8;
    outline: 0;
  }

  &:invalid {
    border-color: #eb5757;
    box-shadow: 0 0 0 var(--outline-size) #f7bcbc;
  }

  &:disabled {
    box-shadow: none;
    background-color: #f2f3f5;
    border-color: #959fa8;
    color: #637381;
  }

  ${hasError &&
  `
    &,
    &:focus {
      border-color: #EB5757;
    }

    &:focus {
      box-shadow: 0 0 0 var(--outline-size) #F7BCBC;
    }
  `}
`;

export const Input = styled.input<any>`
  font-family: ${theme.fontFamily};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  border-radius: 4px;
  border: 1px solid #959fa8;
  color: #1b2126;

  ${({ inputSize }) => {
    let height = '40px';
    let fontSize = '14px';

    if (inputSize === 'sm') {
      height = '32px';
      fontSize = '12px';
    }

    return `
      height: ${height};
      font-size: ${fontSize};
    `;
  }}

  ${pseudoStates}

  /* Hide number arrows/spinners */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type='number'] {
    -moz-appearance: textfield;
    width: 8ch;
    text-align: right;
  }
`;

export const Textarea = styled.textarea<any>`
  box-sizing: border-box;
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #959fa8;
  color: #1b2126;

  ${pseudoStates}
`;
